import dynamic from 'next/dynamic'
import Head from 'next/head'
import Script from 'next/script'
import React from 'react'
// eslint-disable-next-line @rushstack/packlets/mechanics
import {repo} from '../packlets/constants'

const DynamicComponent = dynamic(async () => import('../packlets/cms-ui/app'), {ssr: false})

export default function CMSPage() {
  return (
    <>
      <Head>
        <title>{`CMS - ${repo}`}</title>
        <style>
          {`
            /* https://github.com/decaporg/decap-cms/issues/5092#issuecomment-1256321540 */
            [data-slate-editor] { 
              -webkit-user-modify: read-write !important; 
            }
          `}
        </style>
      </Head>
      <Script>window.CMS_MANUAL_INIT = true</Script>
      <DynamicComponent />
      {/* https://www.netlifycms.org/docs/beta-features/#custom-mount-element */}
      <div id="nc-root" />
    </>
  )
}
